var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIngredientInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2970_111496)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52071 0H0V1.40785H1.42012V16.1902C1.42012 17.7453 2.69174 19.0059 4.26035 19.0059C5.82897 19.0059 7.10059 17.7453 7.10059 16.1902V1.40785H8.52071V0ZM6.39053 7.03923H2.13018V16.1902C2.13018 17.3565 3.08389 18.302 4.26035 18.302C5.43682 18.302 6.39053 17.3565 6.39053 16.1902V7.03923Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94083 3.16765H20V5.1621H9.94083V3.16765Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 7.15655H9.94083V9.151H20V7.15655Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94083 11.1454H20V13.1399H9.94083V11.1454Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 15.1343H9.94083V17.1288H20V15.1343Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2970_111496"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngredientInfo);
export default __webpack_public_path__ + "static/media/IngredientInfo.1a79fd9dee626553795f624e3864c6c9.svg";
export { ForwardRef as ReactComponent };